import { del, get, post } from "../common/apiClient";
import { localStorageGetItem } from "../common/localStorage";
import { getDeviceUUID } from "../common/devicePayload";

const PATH_AUTH = "/auth";

const register = async (body) => {
  const deviceUuid = await getDeviceUUID();
  return await post(PATH_AUTH + "/signup", { ...body, deviceUuid });
};

const login = async (body) => {
  const deviceUuid = await getDeviceUUID();
  return await post(PATH_AUTH + "/login", { ...body, deviceUuid });
};

const loginWithGoogle = async (accessToken) => {
  const deviceUuid = await getDeviceUUID();
  return await post(
    PATH_AUTH + "/google-login",
    {
      accessToken,
      deviceUuid,
    },
    {
      withCredentials: true,
    },
  );
};

const forgotPassword = async (body) => {
  return await post(PATH_AUTH + "/forgot-password", body);
};

const resetPassword = async (body) => {
  return await post(PATH_AUTH + "/reset-password", body);
};

const checkJwtExistsAndExpired = () => {
  // Access token lưu ở HttpOnly cookie -> FE không đọc được
  // Nếu có user trong localStorage thì coi như đã đăng nhập (sẽ được BE kiểm tra khi gọi API)
  const user = localStorage.getItem("user");
  return !!user;
};

const getUserInfo = () => {
  return localStorageGetItem("user");
};

// Session management functions
const getUserSessions = async () => {
  return await get(PATH_AUTH + "/sessions");
};

const logoutSession = async () => {
  return await del(PATH_AUTH + `/sessions`);
};

const logoutAllSessions = async () => {
  return await post(PATH_AUTH + "/logout-all");
};

export {
  register,
  login,
  forgotPassword,
  resetPassword,
  checkJwtExistsAndExpired,
  loginWithGoogle,
  getUserInfo,
  getUserSessions,
  logoutSession,
  logoutAllSessions,
};
